'use client';

import Link, { LinkProps } from 'next/link';
import { AnchorHTMLAttributes } from 'react';

type ExtendedLinkProps = LinkProps & Omit<AnchorHTMLAttributes<HTMLAnchorElement>, keyof LinkProps>;

export default function LinkForZzimcarAndroid({ children, ...linkProps }: ExtendedLinkProps) {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (window?.Android) {
      e.preventDefault();
      window.location.href = linkProps.href as string;
      return;
    }
  };

  return (
    <Link {...linkProps} onClick={handleClick}>
      {children}
    </Link>
  );
}
